import ParentClass from './Parent.js';

class Careers extends ParentClass {
  constructor() {
    super();
    const moduleClass = '.component-job-postings-container';
    if(!super.runThisModule(moduleClass)) return;

    const embed = document.getElementsByTagName('embed').item(0);
    const embedParent = embed.parentNode;

    embedParent.setAttribute('style', 'position:absolute;left:-2000px;top:0px;visibility:hidden;')

    embed.addEventListener('load', function(e){
        setTimeout(function(){
            embedParent.setAttribute('style', 'position:static; visibility:visible;');
        }, 2000);
    });
  }
}

jQuery(document).ready(function() {
    new Careers();
});



// WEBPACK FOOTER //
// ./wp-content/themes/variscale/library/js/classes/Careers.js